import SiteMixins from "@global/mixins/SiteMixins";
import ProductMixins from "@global/mixins/ProductMixins";
import CONST from '@tutils/Constants';
import {orderType} from '@tutils/Property';

export default {
	computed: {},
	mixins: [SiteMixins, ProductMixins],
	methods: {
		buildProductGAObject(product, price, brand, metric1, metric2, categoryCode, positionIndex, collectionMap, entry) {
			const obj = {
				item_name: product.nameEn,
				item_id: product.sku,
				price: this.getGAPrice(price, metric1, metric2),
				item_brand: brand,
				// category: this.getCategory(categoryCode, collectionMap),
				quantity: this.getQuantityGA(metric1, metric2),
				product_bunch: product.bunch,
				product_color: (product.productFilter2Description || "").toUpperCase(),
				// dimension3: product.productFilter3DescriptionEn,
				// dimension4: product.fiber,
				product_use: (product.productUsesEn.trim() || "").toUpperCase(),
				// dimension6: this.getGAProductHeight(product.classifications,collectionMap.division),
				product_weight: this.getGAProductWeight(product.classifications, collectionMap.division),
				product_quantity_measure_unit: CONST.CLASSIFICATION[collectionMap.division].MEASURE,
				product_composition: (product.composizione || "").toUpperCase(),
				// dimension7: product.commercialCompositionEn,
				product_collection: collectionMap ? collectionMap.collection : null,
				product_society: collectionMap ? collectionMap.society : null,
				product_service: collectionMap ? collectionMap.service : null,
				product_pattern: (product.productFilter3DescriptionEn || "").toUpperCase(),
				// dimension12: product.certificationsString ? product.certificationsString : null,
				// dimension13: product.composizione ? product.composizione : null,
				// dimension14: product.tipologia,
				product_family: (product.family || "").toUpperCase(),
				currency: ACC.config.user.currency.isocode,
				product_season: collectionMap ? collectionMap.season : null,
				// dimension18: ACC.config.appView,
				// dimension19: product.colorProduct ? product.colorProduct : null,
				product_selected_quantity: metric1,
				product_selected_dimension: isNaN(metric2) ? 0 : Number(metric2),
				product_cod1: product.cod1,
				product_cod2: product.cod2,
				product_cod3: product.cod3,
				product_cod4: product.cod4,
				product_cod5: product.cod5,
				use_piece_number: !!entry.matricola,
				use_references: !!entry.refProduct,
				item_list_name: entry.itemListName,
			}
			return obj;
		},
		buildProductGAObject2(product, price, brand, metric1, metric2, categoryCode, positionIndex, collectionMap, categoryPath) {
			const obj = {
				item_name: product.nameEn,
				item_id: product.sku ? product.sku : product.cod1 + " - " + product.cod2 + " / " + product.cod3,
				price: this.getGAPrice(product.price, metric1, metric2),
				item_brand: this.getBrand(collectionMap.collection, brand),
				// category: this.getCategory(categoryCode, collectionMap),
				product_bunch: product.bunch,
				product_color: (product.productFilter2Description || "").toUpperCase(),
				// dimension3: product.productFilter3DescriptionEn,
				// dimension4: product.fiber,
				product_use: (product.productUsesEn || "").toUpperCase(),
				// dimension6: this.getGAProductHeight(product.classifications,collectionMap.division),
				product_weight: this.getGAProductWeight(product.classifications, collectionMap.division),
				product_quantity_measure_unit: CONST.CLASSIFICATION[collectionMap.division].MEASURE,
				product_composition: (product.composizione || "").toUpperCase(),
				// dimension7: product.commercialCompositionEn,
				product_collection: collectionMap.collection.includes("000") ? collectionMap.collection : "000".concat(collectionMap.collection),
				product_society: collectionMap.society,
				product_service: collectionMap.service,
				product_pattern: (product.productFilter3DescriptionEn || "").toUpperCase(),
				// dimension12: product.certificationsString,
				// dimension13: product.composizione,
				// dimension14: product.tipologia,
				product_family: (product.family || "").toUpperCase(),
				currency: ACC.config.user.currency.isocode,
				product_season: collectionMap.season,
				// dimension18: ACC.config.appView,
				// dimension19: product.colorProduct ? product.colorProduct : null,
				index: positionIndex,
				product_cod1: product.cod1,
				product_cod2: product.cod2,
				product_cod3: product.cod3,
				product_cod4: product.cod4,
				product_cod5: product.cod5
			}
			return obj;
		},
		buildProductGAObject3(product, price, brand, metric1, metric2, categoryCode, positionIndex, collectionMap) {
			const obj = {
				item_name: product.nameEn,
				item_id: product.sku,
				price: this.getGAPrice(price, metric1, metric2),
				item_brand: this.getBrand(collectionMap.collection, brand),
				// category: this.getCategory(categoryCode, collectionMap),
				product_bunch: product.bunch,
				product_color: (product.productFilter2Description || "").toUpperCase(),
				// dimension3: product.productFilter3DescriptionEn,
				// dimension4: product.fiber,
				product_use: (product.productUsesEn || "").toUpperCase(),
				// dimension6: this.getGAProductHeight(product.classifications,collectionMap.division),
				product_weight: this.getGAProductWeight(product.classifications, collectionMap.division),
				product_quantity_measure_unit: CONST.CLASSIFICATION[collectionMap.division].MEASURE,
				product_composition: (product.composizione || "").toUpperCase(),
				// dimension7: product.commercialCompositionEn,
				product_collection: collectionMap.collection.includes("000") ? collectionMap.collection : "000".concat(collectionMap.collection),
				product_society: collectionMap.society,
				product_service: collectionMap.service,
				product_pattern: (product.productFilter3DescriptionEn || "").toUpperCase(),
				// dimension12: product.certificationsString ? product.certificationsString : null,
				// dimension13: product.composizione,
				// dimension14: product.tipologia,
				product_family: (product.family || "").toUpperCase(),
				currency: ACC.config.user.currency.isocode,
				product_season: collectionMap.season,
				// dimension18: ACC.config.appView,
				// dimension19: product.colorProduct ? product.colorProduct : null,
				product_cod1: product.cod1,
				product_cod2: product.cod2,
				product_cod3: product.cod3,
				product_cod4: product.cod4,
				product_cod5: product.cod5
			}
			return obj;
		},
		buildProductGAObject4(product, price, brand, metric1, metric2, categoryCode, positionIndex, collectionMap) {
			const obj = {
				item_name: product.nameEn,
				item_id: product.sku,
				price: this.getGAPrice(price, metric1, metric2),
				item_brand: this.getBrand(collectionMap.collection, brand),
				product_bunch: product.bunch,
				product_color: (product.productFilter2Description || "").toUpperCase(),
				// dimension3: product.productFilter3DescriptionEn,
				// dimension4: product.fiber,
				product_use: (product.productUsesEn || "").toUpperCase(),
				// dimension6: this.getGAProductHeight(product.classifications,collectionMap.division),
				product_weight: this.getGAProductWeight(product.classifications, collectionMap.division),
				product_quantity_measure_unit: CONST.CLASSIFICATION[collectionMap.division].MEASURE,
				product_composition: (product.composizione || "").toUpperCase(),
				// dimension7: product.commercialCompositionEn,
				product_collection: collectionMap.collection.includes("000") ? collectionMap.collection : "000".concat(collectionMap.collection),
				product_society: collectionMap.society,
				product_service: collectionMap.service,
				product_pattern: (product.productFilter3DescriptionEn || "").toUpperCase(),
				// dimension12: product.certificationsString ? product.certificationsString : null,
				// dimension13: product.composizione,
				// dimension14: product.tipologia,
				product_family: (product.family || "").toUpperCase(),
				currency: ACC.config.user.currency.isocode,
				product_season: collectionMap.season,
				// dimension18: ACC.config.appView,
				// dimension19: product.colorProduct ? product.colorProduct : null,
				product_selected_quantity: isNaN(metric1) ? 1 : metric1,
				product_selected_dimension: isNaN(metric2) ? 0 : Number(metric2),
				product_cod1: product.cod1,
				product_cod2: product.cod2,
				product_cod3: product.cod3,
				product_cod4: product.cod4,
				product_cod5: product.cod5
			}
			return obj;
		},
		buildProductGAObject5(product, price, brand, metric1, metric2, categoryCode, positionIndex, collectionMap) {
			const obj = {
				item_name: product.nameEn,
				item_id: product.sku ? product.sku : product.cod1 + " - " + product.cod2 + " / " + product.cod3,
				item_brand: this.getBrand(collectionMap.collection, brand),
				// category: this.getCategory(categoryCode, collectionMap),
				product_bunch: product.bunch,
				product_color: (product.productFilter2Description || "").toUpperCase(),
				// dimension3: product.productFilter3DescriptionEn,
				// dimension4: product.fiber,
				product_use: (product.productUsesEn || "").toUpperCase(),
				// dimension6: this.getGAProductHeight(product.classifications,collectionMap.division),
				product_weight: this.getGAProductWeight(product.classifications, collectionMap.division),
				product_quantity_measure_unit: CONST.CLASSIFICATION[collectionMap.division].MEASURE,
				// dimension7: product.commercialCompositionEn,
				product_collection: collectionMap.collection.includes("000") ? collectionMap.collection : "000".concat(collectionMap.collection),
				product_society: collectionMap.society,
				product_service: collectionMap.service,
				product_pattern: (product.productFilter3DescriptionEn || "").toUpperCase(),
				// dimension12: product.certificationsString,
				// dimension13: product.composizione,
				// dimension14: product.tipologia,
				product_family: (product.family || "").toUpperCase(),
				product_season: collectionMap.season,
				// dimension18: ACC.config.appView,
				// dimension19: product.colorProduct ? product.colorProduct : null,
				index: positionIndex,
				product_cod1: product.cod1,
				product_cod2: product.cod2,
				product_cod3: product.cod3,
				product_cod4: product.cod4,
				product_cod5: product.cod5
			}
			if (ACC.config.showStorefrontDebugInfo) {
				console.log(JSON.stringify(obj));
			}
			return obj;
		},
		getOrderType(society, flag) {
			if (society) {
				return orderType[society][flag];
			} else if (ACC.config.society) {
				return orderType[ACC.config.society][flag];
			} else {
				return null;
			}
		},
		getQuantityGA(metric1, metric2) {
			if (isNaN(metric2)) {
				return metric1;
			}
			/*if (ACC.config.society === "US3") {
				metric2 = (metric2 / 1.0936).toFixed(2);
			}*/
			return (metric2 * metric1 * 100).toFixed(0);
		},
		getProductEntries(entries, list) {
			let productList = [];
			entries.forEach((entry) => {
				const collectionMap = this.getCollectionMap(entry)
				const gaObject = this.buildProductGAObject(entry.product, entry.totalPrice.value, entry.flagVista, Number(entry.quantity), entry.descriptionCausality, entry.collection, entry.entryNumber, collectionMap, entry)
				if (!!list) { gaObject.item_list_name = list}
				productList.push(gaObject);
			});
			return productList;
		},
		getProductSearch(products, categoryResolvePath, collectionMap, categoryPath) {
			let productList = [];
			products.forEach((product, index) => {
				const gaObject = this.buildProductGAObject2(product, 0, ACC.config.flagVistaDivision, null, null, categoryResolvePath, index + 1, collectionMap, categoryPath)
				productList.push(gaObject);
			});
			return productList;
		},
		getPrice(price) {
			if (price != null) {
				return parseFloat(price.value);
			}
			return 0;
		},
		getGAPrice(price, quantity, dimension) {
			return (price / (quantity * dimension * 100)).toFixed(3)
		},
		getBrand(collection, flag) {
			if (CONST.DIVISION.FLAGS.SHOWROOM.includes(flag)) {
				return flag;
			}
			if (this.isCollectionFabrics(collection)) {
				return CONST.DIVISION.FLAGS.FLAGLOROPIANAFABRICS;
			} else if (this.isCollectionSolbiati(collection)) {
				return CONST.DIVISION.FLAGS.FLAGSOLBIATIFABRICS;
			}
			return flag;
		},
		getTotalTaxFromCart(order) {
			if (order.commOrgConditionMap != null) {
				let totalTax = 0;
				var dataMap = new Map(Object.entries(order.commOrgConditionMap));
				for (const item of dataMap.keys()) {
					if (dataMap.get(item).taxes) {
						var dataMap2 = new Map(Object.entries(dataMap.get(item).taxes));
						for (const tax of dataMap2.keys()) {
							if (dataMap2.get(tax).totalDiscount.value != null) {
								totalTax = totalTax + dataMap2.get(tax).totalDiscount.value;
							}
						}
					}
				}
				return totalTax;
			}
			return 0;
		},
		getDeliveryCostFromCart(order) {
			if (order.commOrgConditionMap != null) {
				let totalDeliveryCost = 0;
				var dataMap = new Map(Object.entries(order.commOrgConditionMap));
				for (const item of dataMap.keys()) {
					if (dataMap.get(item).deliveryCost != null && dataMap.get(item).deliveryCost.totalDiscount.value != null) {
						totalDeliveryCost = totalDeliveryCost + dataMap.get(item).deliveryCost.totalDiscount.value;
					}
				}
				return totalDeliveryCost;
			}
			return 0;
		},
		getCollectionMap(entry) {
			const splitCollection = entry.collection.split('-');
			return {
				'society': splitCollection.pop(),
				'division': splitCollection.pop(),
				'collection': splitCollection.pop(),
				'service': splitCollection.pop(),
				'season': splitCollection.pop(),
			}
		},
		getEntriesFromCheckout(cart, step) {
			var commOrg1 = cart.commercialOrganizationData.code;
			var dataMap = new Map(Object.entries(cart.entriesMap));
			for (const item of dataMap.keys()) {
				if (item.includes(commOrg1)) {
					this.printSteps(dataMap.get(item), step, cart)
				}
			}
		},
		getGAProductWeight(productClassification, division) {
			const classification = this.getProductWeight(productClassification, division);
			return classification ? Number(classification.value) : null;
		},
		getGAProductHeight(productClassification, division) {
			const classification = this.getProductHeight(productClassification, division);
			return classification ? Number(classification.value) : null;
		},
		getGAProductMinHeight(productClassification, division) {
			const classification = this.getProductMinHeight(productClassification, division);
			return classification ? Number(classification.value) : null;
		},
		getDimension(dimension) {
			const parsedDim = String(dimension).replace(',', '.');
			return isNaN(parsedDim) ? 0 : Number(parsedDim);
		},
		pushEvent(objectEvent) {
			ACC.log.info({'pushEvent': objectEvent})
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ecommerce: null});
			window.dataLayer.push(objectEvent);
		},
		getCommercialOrganization(){
			const flagVistaDivision = !!ACC.config.flagVistaDivision ? ACC.config.flagVistaDivision : CONST.DIVISION.FLAGS.FLAGLOROPIANAFABRICS;
			return CONST.DIVISION.COMMERCIAL_ORGANIZATION[flagVistaDivision][ACC.config.society];
		}
	},
}



// WEBPACK FOOTER //
// ./src/global/lptGoogleAnalytics/mixins/GAMixins.js